/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // .product-tabs__head's own CSS position:sticky is bounded by
  // .product-tabs's box (see theme.css), so it releases as soon as the
  // Pair With panel's content ends - well before Reviews (a separate
  // section) even starts. This keeps the nav visually pinned further,
  // through Reviews, until the [data-sticky-until] target section (see
  // product-tabs.liquid) reaches it, via a fixed-position clone shown
  // only for that in-between range - the original element and its
  // native sticky behavior are left untouched for the range where they
  // already work correctly.
  function initStickyUntil(root, nav) {
    var targetId = root.getAttribute('data-sticky-until');
    var target = targetId ? document.getElementById(targetId) : null;
    // The named section can be renamed or replaced in the theme editor; fall
    // back to whatever section follows Reviews so the pinned bar still works.
    if (!target) {
      var lastLink = root.querySelector('[data-scroll-tabs-link]:last-of-type');
      var reviews = lastLink ? document.getElementById(lastLink.getAttribute('data-target')) : null;
      target = reviews ? reviews.nextElementSibling : null;
    }
    if (!nav || !target) return;

    var clone = null;
    var ensureClone = function() {
      if (clone) return clone;
      clone = nav.cloneNode(true);
      clone.classList.add('product-tabs__head--pinned-clone');
      // Avoid double-initializing the horizontal-scroll/scrollbar
      // plugin (data-scrollbar) on this second copy of the markup.
      clone.removeAttribute('data-scrollbar');
      var cloneLinks = Array.prototype.slice.call(clone.querySelectorAll('[data-scroll-tabs-link]'));
      cloneLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          var panel = document.getElementById(link.getAttribute('data-target'));
          if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
      document.body.appendChild(clone);
      return clone;
    };

    var ticking = false;
    var update = function() {
      ticking = false;
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--menu-height-sticky')) || 0;
      var navRect = nav.getBoundingClientRect();
      // While natively stuck, the original sits pinned at exactly
      // headerHeight; once its container runs out of room for that,
      // it reverts to its normal (now far above the viewport, and
      // strongly negative) position - a couple of px of tolerance
      // absorbs sub-pixel rounding without misreading either state.
      var nativeReleased = navRect.top < headerHeight - 2;
      var reachedTarget = target.getBoundingClientRect().top <= headerHeight + nav.offsetHeight;

      if (nativeReleased && !reachedTarget) {
        var c = ensureClone();
        var parentRect = nav.parentElement.getBoundingClientRect();
        c.style.position = 'fixed';
        c.style.top = headerHeight + 'px';
        c.style.left = parentRect.left + 'px';
        c.style.width = parentRect.width + 'px';
        c.style.margin = '0';
        c.style.zIndex = '2';
        // The clone sits in <body>, so it can't inherit the section's --bg. Use
        // the background of the section currently under it, and bleed it out to
        // the screen edges so no strip of a different colour shows beside it.
        var under = document.elementFromPoint(window.innerWidth / 2, headerHeight + nav.offsetHeight + 4);
        var bg = '';
        while (under && under !== document.documentElement) {
          var b = getComputedStyle(under).backgroundColor;
          if (b && b !== 'rgba(0, 0, 0, 0)' && b !== 'transparent') { bg = b; break; }
          under = under.parentElement;
        }
        if (bg) {
          c.style.background = bg;
          c.style.boxShadow = '0 0 0 100vw ' + bg;
          c.style.clipPath = 'inset(0 -100vw)';
        }
        c.style.display = '';
      } else if (clone) {
        clone.style.display = 'none';
      }
    };
    var onScroll = function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('theme:resize', update);
    update();
  }

  // Product page "scroll tabs": clicking a tab link scrolls to that
  // panel (all panels stay in the page, full height, stacked) instead of
  // hiding the others, and the sticky nav highlights whichever panel is
  // currently in view. Deliberately does not reuse the generic
  // .tab-link/.tab-content/data-tabs-holder markup that the shared Tabs
  // behavior in theme.js uses for related-products and collection tabs,
  // so the two don't attach to the same elements and fight each other.
  function initScrollTabs(root) {
    var nav = root.querySelector('.product-tabs__head');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-scroll-tabs-link]'));
    // Resolve each panel by the link's data-target id rather than scoping
    // to [data-scroll-tabs-panel] inside root, since a tab (e.g. Reviews)
    // can point at a section that lives elsewhere on the page.
    var panels = links
      .map(function(link) { return document.getElementById(link.getAttribute('data-target')); })
      .filter(Boolean);

    if (!links.length || !panels.length) return;

    var setNavHeightVar = function() {
      if (!nav) return;
      var navHeight = nav.offsetHeight;
      root.style.setProperty('--product-tabs-head-height', navHeight + 'px');
      // The tabs nav sticks just below the sticky site header
      // (.product-tabs__head's own top: var(--menu-height-sticky)),
      // so a scrolled-to panel needs clearance for both, not just the
      // nav. --menu-height-sticky, not --header-height: the latter
      // bakes in the (non-sticky) announcement bar's height too.
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--menu-height-sticky')) || 0;
      var scrollOffset = navHeight + headerHeight;
      // Panels inside .product-tabs get this from the CSS variable above,
      // but a panel that lives elsewhere on the page (e.g. the Reviews
      // link's target, a separate app section) has no way to see that
      // variable, so set it directly here too.
      panels.forEach(function(panel) {
        panel.style.scrollMarginTop = scrollOffset + 'px';
      });
    };
    setNavHeightVar();
    document.addEventListener('theme:resize', setNavHeightVar);

    // Keep the active tab centred in the (horizontally scrolling) tab row, so
    // on phones it doesn't drift out of view as the page scrolls. Also applies
    // to the pinned clone shown over the Reviews section.
    var centreActive = function() {
      var navs = [nav, document.querySelector('.product-tabs__head--pinned-clone')];
      navs.forEach(function(n) {
        if (!n) return;
        var scroller = n.querySelector('.tabs');
        var active = n.querySelector('.product-tabs__link.is-active');
        if (!scroller || !active || scroller.scrollWidth <= scroller.clientWidth + 1) return;
        var left = active.offsetLeft - (scroller.clientWidth - active.offsetWidth) / 2;
        var max = scroller.scrollWidth - scroller.clientWidth;
        scroller.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: 'smooth' });
      });
    };

    var setActive = function(targetId) {
      var changed = false;
      links.forEach(function(link) {
        var on = link.getAttribute('data-target') === targetId;
        if (on && !link.classList.contains('is-active')) changed = true;
        link.classList.toggle('is-active', on);
      });
      var clone = document.querySelector('.product-tabs__head--pinned-clone');
      if (clone) {
        Array.prototype.forEach.call(clone.querySelectorAll('[data-scroll-tabs-link]'), function(l) {
          l.classList.toggle('is-active', l.getAttribute('data-target') === targetId);
        });
      }
      if (changed) centreActive();
    };

    links.forEach(function(link) {
      link.addEventListener('click', function() {
        var panel = document.getElementById(link.getAttribute('data-target'));
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    initStickyUntil(root, nav);

    // A tab becomes active once its section's top edge reaches the bottom of
    // the sticky bar (which is where clicking a tab scrolls it to), not when it
    // first peeks into the viewport.
    var spyTicking = false;
    var spy = function() {
      spyTicking = false;
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--menu-height-sticky')) || 0;
      var line = headerHeight + (nav ? nav.offsetHeight : 0) + 2;
      var current = panels[0];
      panels.forEach(function(panel) {
        if (panel.getBoundingClientRect().top <= line) current = panel;
      });
      if (current) setActive(current.id);
    };
    var onSpyScroll = function() {
      if (spyTicking) return;
      spyTicking = true;
      window.requestAnimationFrame(spy);
    };
    document.addEventListener('scroll', onSpyScroll, { passive: true });
    document.addEventListener('theme:resize', spy);

    setActive(links[0].getAttribute('data-target'));
    spy();
  }

  function initAllScrollTabs() {
    var roots = document.querySelectorAll('[data-scroll-tabs]');
    roots.forEach(function(root) { initScrollTabs(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScrollTabs);
  } else {
    initAllScrollTabs();
  }

  // FAQ page topic sidebar (sections/section-faq-topics.liquid): clicking
  // a nav item shows the matching .faq-group (topic heading + its
  // questions) and hides the rest, instead of reloading. Liquid already
  // renders the correct starting group visible to match the starting
  // .is-active nav item, so this only has to react to clicks - no
  // initial sync needed. The accordion open/close behavior itself is
  // untouched - it's the theme's existing data-accordion-trigger/-body
  // markup, so this only owns group visibility.
  function initFaqTopics(root) {
    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-faq-topic-trigger]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    if (!navItems.length || !groups.length) return;

    navItems.forEach(function(navItem) {
      navItem.addEventListener('click', function() {
        var topic = navItem.getAttribute('data-topic');
        navItems.forEach(function(item) {
          item.classList.toggle('is-active', item === navItem);
        });
        groups.forEach(function(group) {
          group.hidden = topic !== 'all' && group.getAttribute('data-topic') !== topic;
        });
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initAllFaqTopics() {
    var roots = document.querySelectorAll('[data-faq-topics-root]');
    roots.forEach(function(root) { initFaqTopics(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFaqTopics);
  } else {
    initAllFaqTopics();
  }

  // Store locator (ProMap app): flag the scrollable store list's wrapper while
  // there is more content below, so CSS can show a "scroll for more" fade.
  // The fade lives on the wrapper because a sticky pseudo-element inside the
  // scroller itself never pinned to the bottom.
  function initStoreLocatorScrollHint() {
    var container = document.querySelector(".scasl-container");
    if (!container) return;

    var bound = [];

    function update(list) {
      var host = list.parentElement;
      var more = list.scrollHeight - list.clientHeight - list.scrollTop > 8;
      host.style.setProperty("--scasl-fade-left", list.offsetLeft + "px");
      host.style.setProperty("--scasl-fade-w", list.clientWidth + "px");
      host.style.setProperty("--scasl-list-bottom", (list.offsetTop + list.offsetHeight) + "px");
      host.classList.toggle("has-more-below", more);
    }

    function bind(list) {
      if (bound.indexOf(list) !== -1) return;
      bound.push(list);
      list.addEventListener("scroll", function() { update(list); }, { passive: true });
      new MutationObserver(function() { update(list); }).observe(list, { childList: true, subtree: true });
      window.addEventListener("resize", function() { update(list); });
      window.addEventListener("load", function() { update(list); });
      // The wrapper's height settles after the map initializes, so re-measure
      // whenever either box changes size, not just on scroll.
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function() { update(list); });
        ro.observe(list);
        ro.observe(list.parentElement);
      }
      update(list);
    }

    function scan() {
      container.querySelectorAll(".scasl-location-list").forEach(bind);
    }

    scan();
    new MutationObserver(scan).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStoreLocatorScrollHint);
  } else {
    initStoreLocatorScrollHint();
  }

  // Policy pages (Settings > Policies): Shopify renders them without a theme
  // template and their subheadings are plain <strong> tags. Tag the short ones
  // so CSS can style them as headings; long <strong> text stays as body copy.
  function initPolicySubheads() {
    document.querySelectorAll(".shopify-policy__body strong").forEach(function(el) {
      if (el.textContent.trim().length <= 100) el.classList.add("policy-subhead");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPolicySubheads);
  } else {
    initPolicySubheads();
  }

  // Rivo loyalty page: the app renders it inside a same-origin iframe, which
  // theme CSS can't reach. Load assets/loyalty-page.css (URL passed on the
  // wrapper by templates/page.rivo-loyalty.liquid) plus the theme's fonts into
  // it. Rivo can rewrite the iframe document, so keep checking that it is there.
  function initLoyaltyPageStyle() {
    var wrapper = document.getElementById("rivo-page-wrapper");
    var cssUrl = wrapper && wrapper.getAttribute("data-loyalty-css");
    if (!cssUrl) return;

    var fontCss = null;
    function themeFontFaces() {
      if (fontCss !== null) return fontCss;
      fontCss = "";
      Array.prototype.forEach.call(document.styleSheets, function(sheet) {
        var rules;
        try { rules = sheet.cssRules; } catch (e) { return; }
        Array.prototype.forEach.call(rules, function(rule) {
          if (rule.type === CSSRule.FONT_FACE_RULE) {
            // The iframe base is about:blank, so protocol-relative URLs need a scheme.
            fontCss += rule.cssText.replace(/url\((['"]?)\/\//g, "url($1https://") + "\n";
          }
        });
      });
      return fontCss;
    }

    // Rivo sizes the iframe once, before our CSS changes the layout, so it can end
    // up taller (blank gap) or shorter than the content. Fit it to the content.
    function fitFrame(frame, doc) {
      var bottom = 0;
      Array.prototype.forEach.call(doc.querySelectorAll(".page-section"), function(section) {
        var rect = section.getBoundingClientRect();
        if (rect.height > 0) bottom = Math.max(bottom, rect.bottom + (doc.defaultView.pageYOffset || 0));
      });
      if (bottom && Math.abs(frame.offsetHeight - bottom) > 2) {
        frame.style.setProperty("height", Math.ceil(bottom) + "px", "important");
        frame.style.setProperty("min-height", "0", "important");
      }
    }

    function apply() {
      var frame = document.getElementById("rivo-full-page-widget");
      var doc = frame && frame.contentDocument;
      if (!doc || !doc.head) return;
      if (doc.getElementById("na-loyalty-css")) { fitFrame(frame, doc); return; }
      var fonts = doc.createElement("style");
      fonts.id = "na-loyalty-fonts";
      fonts.textContent = themeFontFaces();
      doc.head.appendChild(fonts);
      var link = doc.createElement("link");
      link.id = "na-loyalty-css";
      link.rel = "stylesheet";
      link.href = cssUrl;
      doc.head.appendChild(link);
    }

    apply();
    setInterval(apply, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLoyaltyPageStyle);
  } else {
    initLoyaltyPageStyle();
  }

  // Collection filter pills: a pill is "selected" (shown inverted, see theme.css)
  // when its filter has a value other than All, or the sort differs from the
  // collection's default. The server renders the initial state; this keeps it in
  // step when the sort or a filter changes without a page load.
  function initFilterPillState(root) {
    (root || document).querySelectorAll('.collection__filters__inner').forEach(function (inner) {
      if (inner.__naPillState) return;
      inner.__naPillState = true;
      function sync() {
        inner.querySelectorAll('.sidebar__filter__group').forEach(function (group) {
          var on = false;
          if (group.classList.contains('collection-sort')) {
            var current = group.getAttribute('data-sort-enabled');
            var fallback = group.getAttribute('data-sort-default');
            on = !!fallback && current !== fallback;
          } else {
            var label = group.querySelector('.sidebar__heading__label');
            if (label) {
              var value = label.textContent.replace(/^[^:]*:/, '').trim().toLowerCase();
              on = value !== '' && value !== 'all';
            }
          }
          group.classList.toggle('sidebar__filter__group--active', on);
        });
      }
      new MutationObserver(sync).observe(inner, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['data-sort-enabled']
      });
      sync();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initFilterPillState(); });
  } else {
    initFilterPillState();
  }
  document.addEventListener('shopify:section:load', function (e) { initFilterPillState(e.target); });

  // Product page gallery dots (phones, only when the thumbnails
  // overflow their row): one dot per visible thumbnail, the
  // active one follows the thumbnail the theme marks as .is-activated, and
  // clicking a dot clicks that thumbnail so the theme's own slideshow moves.
  function initProductDots(root) {
    (root || document).querySelectorAll('.product__media__wrapper').forEach(function (wrap) {
      if (wrap.__naDots) return;
      var holder = wrap.querySelector('[data-thumbs-holder]');
      if (!holder) return;
      wrap.__naDots = true;
      var dotsEl = document.createElement('div');
      dotsEl.className = 'na-reel-dots na-product-dots';
      dotsEl.setAttribute('data-na-product-dots', '');
      wrap.insertBefore(dotsEl, holder.nextSibling);
      var strip = holder.querySelector('[data-product-thumbs]') || holder;

      function thumbs() {
        return Array.prototype.filter.call(holder.querySelectorAll('[data-slideshow-thumbnail]'), function (t) {
          return !t.classList.contains('hide');
        });
      }
      function render() {
        var list = thumbs();
        // Only needed when the thumbnails overflow their row (or column).
        var overflowing = strip.scrollWidth > strip.clientWidth + 1 || strip.scrollHeight > strip.clientHeight + 1;
        dotsEl.classList.toggle('is-needed', list.length > 1 && overflowing);
        if (dotsEl.children.length !== list.length) {
          dotsEl.innerHTML = '';
          list.forEach(function (th, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'na-reel-dots__dot';
            b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + list.length);
            b.addEventListener('click', function () {
              var current = thumbs();
              if (current[i]) current[i].click();
            });
            dotsEl.appendChild(b);
          });
        }
        Array.prototype.forEach.call(dotsEl.children, function (d, i) {
          var on = !!(list[i] && list[i].classList.contains('is-activated'));
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
      new MutationObserver(render).observe(holder, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['class']
      });
      window.addEventListener('resize', render);
      window.addEventListener('load', render);
      if (window.ResizeObserver) new ResizeObserver(render).observe(strip);
      render();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initProductDots(); });
  } else {
    initProductDots();
  }
  document.addEventListener('shopify:section:load', function (e) { initProductDots(e.target); });

  // Focus carousel ([data-na-reel] on a custom-content row of videos). On
  // tablet/desktop all blocks stay in view and one is "active" (larger, playing);
  // swipe, drag, horizontal wheel, arrow keys or the dots move the active one.
  // On phones the row scrolls sideways with scroll-snap and the block nearest
  // the centre is the active one. Only the active block's video plays.
  function initReels(root) {
    (root || document).querySelectorAll('[data-na-reel]').forEach(function (reel) {
      if (reel.__naReel) return;
      reel.__naReel = true;
      var wrap = reel.parentElement;
      var items = Array.prototype.filter.call(reel.children, function (c) {
        return c.classList && c.classList.contains('brick__block');
      });
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-na-dot]'));
      if (items.length < 2) return;
      var mq = window.matchMedia('(max-width: 1099px)');
      var mqPhone = window.matchMedia('(max-width: 767px)');
      var active = -1;
      var visible = true;

      function syncVideos() {
        items.forEach(function (it, n) {
          var v = it.querySelector('video');
          if (!v) return;
          if (n === active && visible) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      function setActive(i) {
        if (i === active) return;
        active = i;
        items.forEach(function (it, n) { it.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === i);
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        syncVideos();
      }

      // Scroll position that "selects" item i. Phones centre the item; tablet
      // puts the first item at the left edge, the last at the right edge and
      // centres the ones between (matches the CSS snap points in theme.css).
      function targetFor(i) {
        var it = items[i];
        var max = reel.scrollWidth - reel.clientWidth;
        var centred = it.offsetLeft + it.offsetWidth / 2 - reel.clientWidth / 2;
        if (!mqPhone.matches) {
          if (i === 0) return 0;
          if (i === items.length - 1) return max;
        }
        return Math.max(0, Math.min(max, centred));
      }

      function nearest() {
        var best = 0, bestDist = Infinity;
        items.forEach(function (it, n) {
          var d = Math.abs(reel.scrollLeft - targetFor(n));
          if (d < bestDist) { bestDist = d; best = n; }
        });
        return best;
      }

      function scrollToItem(i, smooth) {
        reel.scrollTo({ left: targetFor(i), behavior: smooth ? 'smooth' : 'auto' });
      }

      function step(dir) {
        setActive(Math.max(0, Math.min(items.length - 1, active + dir)));
      }

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () {
          if (mq.matches) scrollToItem(n, true); else setActive(n);
        });
      });

      // Phones: scroll position drives the active block.
      var ticking = false;
      reel.addEventListener('scroll', function () {
        if (!mq.matches || ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; setActive(nearest()); });
      }, { passive: true });

      // Tablet/desktop: swipe or drag, horizontal wheel, arrow keys.
      var start = null, suppressClick = false;
      reel.addEventListener('pointerdown', function (e) {
        if (mq.matches) return;
        start = { x: e.clientX, y: e.clientY };
        suppressClick = false;
      });
      document.addEventListener('pointerup', function (e) {
        if (!start) return;
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          suppressClick = true;
          step(dx < 0 ? 1 : -1);
        }
      });
      reel.addEventListener('click', function (e) {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
      }, true);
      reel.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var lastWheel = 0;
      reel.addEventListener('wheel', function (e) {
        if (mq.matches) return;
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 8) {
          e.preventDefault();
          var now = Date.now();
          if (now - lastWheel > 700) { lastWheel = now; step(e.deltaX > 0 ? 1 : -1); }
        }
      }, { passive: false });
      reel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          if (mq.matches) scrollToItem(Math.max(0, Math.min(items.length - 1, active + dir)), true);
          else step(dir);
          e.preventDefault();
        }
      });

      // Pause everything while the row is off-screen.
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          syncVideos();
        }).observe(reel);
      }

      function onModeChange() {
        if (mq.matches) {
          scrollToItem(Math.max(active, 0), false);
        } else {
          reel.scrollLeft = 0;
        }
      }
      if (mq.addEventListener) {
        mq.addEventListener('change', onModeChange);
        mqPhone.addEventListener('change', onModeChange);
      }

      setActive(0);
      onModeChange();
    });
  }
  function bootReels() { initReels(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootReels);
  } else {
    bootReels();
  }
  document.addEventListener('shopify:section:load', function (e) { initReels(e.target); });

  // Sideways scrollers on tablet and mobile (testimonials, custom-content
  // videos): a container with [data-na-scroller] scrolls horizontally below
  // 1100px (see theme.css), and its sibling [data-na-scrollbar] is the
  // progress bar, styled like the Gallery section's. The bar's track width is
  // the visible share of the content; its position follows scrollLeft.
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-na-scroller]').forEach(function (scroller) {
      if (scroller.__naScroller) return;
      scroller.__naScroller = true;
      var wrap = scroller.parentElement;
      var bar = wrap && wrap.querySelector('[data-na-scrollbar]');
      var track = bar && bar.querySelector('[data-na-track]');
      if (!bar || !track) return;

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        var overflowing = max > 1;
        bar.classList.toggle('hide', !overflowing);
        if (!overflowing) return;
        var share = Math.max(5, (scroller.clientWidth / scroller.scrollWidth) * 100);
        var fraction = Math.min(1, Math.max(0, scroller.scrollLeft / max));
        // translateX percentages are relative to the track itself.
        var offset = fraction * (100 / share - 1) * 100;
        bar.style.setProperty('--track-width', share + '%');
        bar.style.setProperty('--position', offset + '%');
      }

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
      update();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initScrollers(); });
  } else {
    initScrollers();
  }
  document.addEventListener('shopify:section:load', function (e) { initScrollers(e.target); });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
